import AssociationGridFactory from '@/Factories/ControlFactories/AssociationGridFactory';
import ComponentManager from '@/Management/ComponentManager';
import LinkViewModelType from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelType from '@/ViewModels/Controls/ImageViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import NavigationService from '@/Management/NavigationService';
import Messenger from '@/Utility/Messenger';

export default class ChangelogAssociationGridFactory extends AssociationGridFactory {

    private isChangeLogActive: boolean;

    protected LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelType>('LinkViewModel');
    protected ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelType>('ImageViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');

    constructor(params: any) {
        super(params);
        this.isChangeLogActive = this.paramOrDefault(params.isChangeLogActive, true);

        this.registerForMessages();
    }

    /**
     * Registriert sich f�r die Nachricht "DetailViewContextAppliedMessage", sodass das Grid aktualisiert
     */
    private registerForMessages(): void {
        if (!this.isChangeLogActive)
            return;

        Messenger.registerForMessageId('DetailViewContextAppliedMessage',
            (_) => {
                if (this.isDisposed)
                    return;
                this.dataGrid.refresh();
            },
            this);
    }

    /**
    * @override
    * @inheritdoc
    */
    protected showEditButton(): boolean {
        return false;
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createToolbarSecondaryLinks(): KnockoutComputed<LinkViewModelType[]> {
        return this.defineComputed(() => {
            const baseLinks = super.createToolbarSecondaryLinks()();
            const fullScreenLink = new this.LinkViewModel({
                image: new this.ImageViewModel({
                    source: GlobalConfiguration.inlineImages.OPEN_FULLSCREEN
                }),
                tooltip: new this.LabelViewModel({
                    ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.PERSISTENTOBJECT_CHANGELOGS_SHOWPOPUP'
                }),
                onClick: () => {
                    NavigationService.getInstance().loadViewFactoryIsolated('ChangelogPopup',
                        {
                            pdTypeName: this.context.genericObject.pdTypeName,
                            pdoId: this.context.genericObject.pdoId,
                            itOperator: this.dataGrid.getIteratorOperator()
                        }, true);
                }
            });
            baseLinks.push(fullScreenLink);
            return baseLinks;
        });
    }
}

ComponentManager.setFactory('ChangelogAssociationGrid', ChangelogAssociationGridFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');